import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Back } from '@triplabo/web/components';
import { isHardware } from '@triplabo/web/utils';
import styles from './terms.module.css';

interface RuleProps {
  onClose: () => void;
}

// 为了处理 i18n 中的嵌套内容结构
type ContentSubItem = {
  title: string;
  content?: string[];
};

type SectionContent = string | ContentSubItem;

interface Section {
  title: string;
  content: SectionContent[];
}

interface CancelTerms {
  title: string;
  textTitle: string;
  content: Section[];
  bottomDesc: string;
}

const Rule: React.FC<RuleProps> = observer(({ onClose }) => {
  const { t } = useTranslation();

  const cancelTerms = t('cancelTerms', { returnObjects: true }) as CancelTerms;

  return (
    <div className={isHardware ? styles.hardware : styles.normal}>
      <div className={styles.wrapper}>
        <Back inline title={cancelTerms.title} onBack={onClose} />
        <div className={styles.container}>
          <h1 className={styles.mainTitle}>{cancelTerms.textTitle}</h1>

          <div className={styles.ruleContent}>
            {cancelTerms.content.map(
              (section: Section, sectionIndex: number) => (
                <div key={sectionIndex} className={styles.section}>
                  <h2 className={styles.sectionTitle}>
                    {sectionIndex + 1}. {section.title}
                  </h2>
                  {section.content.map(
                    (item: SectionContent, itemIndex: number) => {
                      if (typeof item === 'string') {
                        return (
                          <p key={itemIndex} className={styles.paragraph}>
                            {sectionIndex + 1}.{itemIndex + 1}. {item}
                          </p>
                        );
                      } else {
                        return (
                          <div key={itemIndex} className={styles.paragraph}>
                            <p>
                              {sectionIndex + 1}.{itemIndex + 1}. {item.title}
                            </p>
                            {item.content && (
                              <div className={styles.subContent}>
                                {item.content.map(
                                  (subItem: string, subIndex: number) => (
                                    <p
                                      key={subIndex}
                                      className={styles.subParagraph}
                                    >
                                      {subItem}
                                    </p>
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        );
                      }
                    }
                  )}
                </div>
              )
            )}
          </div>

          <p className={styles.bottomDesc}>{cancelTerms.bottomDesc}</p>
        </div>
      </div>
    </div>
  );
});

export default Rule;
